import React from "react";
import { ArrowRight, Layers, Maximize2, Palette, Wrench } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const costFactors = [{
  icon: Maximize2,
  title: "Badrummets storlek",
  description: "Storlek och planlösning påverkar mängden material och omfattningen av arbetet."
}, {
  icon: Wrench,
  title: "Installationer & VVS",
  description: "Flytt av vatten, avlopp, golvvärme och andra installationer kan påverka både arbetstid och kostnad."
}, {
  icon: Palette,
  title: "Material & inredning",
  description: "Val av kakel, klinker, kommod, dusch, badkar och blandare påverkar badrummets slutpris."
}, {
  icon: Layers,
  title: "Projektets omfattning",
  description: "Rivning, underarbete och hur mycket som behöver byggas om påverkar den totala kostnaden för renoveringen."
}];
export default function CostGuide() {
  return <section id="renovationcostguide" data-nav="light" className="bg-background text-foreground font-default py-24 lg:py-32">
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Header Area */}
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto mb-16 lg:mb-20">
          <Badge variant="secondary" className="mb-4 px-3.5 py-1 text-xs font-medium tracking-wide uppercase rounded-full border border-border bg-secondary text-secondary-foreground">
            Pris &amp; offert
          </Badge>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-foreground mb-6">Vad kostar det att renovera badrum i Värmland?</h2>

          <p className="text-muted-foreground text-base sm:text-lg leading-relaxed">Priset på en badrumsrenovering beror bland annat på storlek, befintligt skick, materialval och hur omfattande arbetet är. Vi hjälper till med allt från funktionella standardbadrum till mer exklusiva och skräddarsydda badrum, utifrån dina önskemål och din budget. Även förändringar av planlösning, VVS-installationer, el, golvvärme, kakel, klinker och badrumsinredning påverkar den totala kostnaden.</p>
        </div>

        {/* 4 Factor Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16 lg:mb-20">
          {costFactors.map((factor, i) => {
          const IconComponent = factor.icon;
          return <div key={factor.title} data-index={i} className="h-full">
                <Card className="h-full border border-border bg-card rounded-lg p-2 shadow-xs transition-shadow hover:shadow-md">
                  <CardHeader className="pb-3 pt-4 px-4">
                    <div className="size-10 rounded-md bg-accent text-accent-foreground flex items-center justify-center mb-3">
                      <IconComponent className="size-5 text-primary" />
                    </div>
                    <CardTitle className="text-lg font-medium text-card-foreground">
                      <h3 className="text-lg font-medium">{factor.title}</h3>
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-4 pb-4">
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {factor.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>

        {/* CTA Card Section */}
        <div className="bg-secondary/60 border border-border rounded-xl p-8 sm:p-10 lg:p-12 text-center max-w-4xl mx-auto shadow-xs">
          <h3 className="text-2xl sm:text-3xl font-semibold text-foreground mb-4">Få offert på badrumsrenovering i Värmland</h3>
          <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto mb-8 leading-relaxed">
            Vill du veta vad det kostar att renovera just ditt badrum? Kontakta
            oss för en genomgång av dina önskemål och badrummets förutsättningar.
            Därefter kan vi ta fram en tydlig offert för din badrumsrenovering i
            Värmland.
          </p>
          <div className="flex justify-center">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md px-8 py-3 text-base font-medium shadow-sm transition-colors group">
              <Link to="/QuoteRequestPage">
                Begär offert
                <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}